import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody } from "../../partials/content/Portlet";
import DataGrid, { Button, Column, SearchPanel, StateStoring, Export, ColumnChooser, ColumnFixing, Editing, HeaderFilter, Summary, TotalItem, Scrolling, Toolbar, Item as ToolbarItem, Selection, FilterPanel, FilterRow } from 'devextreme-react/data-grid';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import ContractGenericDraftEditModal, { RESPONSES as EditModalResponses } from './_CustomComponents/ContractGenericDraftEditModal';
import * as genericDraftsCrud from '../../crud/genericDrafts.crud';
import { Link } from "react-router-dom";
import { getGenericDraftStatuses, getGenericDraftSources } from '../../shared/lookup';
import { Switch } from 'devextreme-react';
import * as utils from "../../../_metronic/utils/utils";
import { withRouter } from '../../shared/hoc/withRouter';
import SystemHelper from "../../shared/systemHelper";

const customFilterStorageKey = "FD-GenericDraftsCustomFilter3";
const customFilterStoragePeriod = 14 * 24 * 60 * 60; // default: seconds for 14 day


class GenericDrafts extends React.Component {
    constructor(props) {
        super(props);
        this.localStorageKey = process.env.REACT_APP_PRODUCT_KEY + process.env.REACT_APP_ENVIRONMENT + "_GenericDrafts_1";

        this.allowDelete = this.props.protectedRouteProps.allowDelete;
        this.gridRef = React.createRef();
        this.genericDraftStatuses = getGenericDraftStatuses(this.props.intl);
        this.genericDraftSources = getGenericDraftSources(this.props.intl);
        const localStorateFilters = utils.getStorage(customFilterStorageKey);
        let customFilter = localStorateFilters
            ? JSON.parse(localStorateFilters)
            : {
                includeAssigned: false,
            };


        this.state = {
            isBusy: true,
            drafts: null,
            showAddActionModal: false,
            showEditDraftModal: false,
            editingDraft: null,
            customFilter
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const searchParams = new URLSearchParams(location.search);

        this.loadDrafts(searchParams);

        utils.setStorage(
            customFilterStorageKey,
            JSON.stringify(this.state.customFilter),
            customFilterStoragePeriod
        );
    }
    componentDidUpdate(prevProps, prevState) {

    }

    loadDrafts = async (searchParams) => {
        this.setState({ isBusy: true }, async () => {
            try {
                const { data: drafts } = await genericDraftsCrud.getRegisterList(
                    this.props.contract.contractid,
                    this.state.customFilter.includeAssigned,
                    this.props.contractTemplate.accessibleWfIds
                );
                this.setState({ drafts, isBusy: false });
            } catch (err) {
                this.setState({ drafts: null, isBusy: false });
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        })
    }


    deleteActionPromise = (contractgenericdraftid) => {
        return new Promise(async (resolve, reject) => {
            try {
                await genericDraftsCrud.deleteDraft(contractgenericdraftid);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    //deleting row
    onRowRemoving = async (e) => {
        // const { contractid } = this.props.contract;
        // this.gridRef.current.instance().clearSelection();
        e.cancel = this.deleteActionPromise(e.data.contractgenericdraftid);
    }


  onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.MAIN_SHEET' }));

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
    }).then(() => {  // Using arrow function here
      workbook.xlsx.writeBuffer()
        .then((buffer) => {  // Using arrow function here to preserve 'this'
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.CONTRACT_SECONDARY_DATES_CHANGE_LOGS' }) + '.xlsx'
          );
        });
    });
  };

    onEditDraftDialogResult = (result) => {
        if (result === EditModalResponses.SAVE) {
            this.loadDrafts();
        }
        this.setState({ showEditDraftModal: false, editingDraft: null });
    }

    assignIconClicked = async (e) => {
        this.setState({ editingDraft: { ...e.row.data }, showEditDraftModal: true });
    }





    validateDelete = (draftItem) => {
        let allowed = true;
        let error = "";
        if (draftItem.status === 2) {
            allowed = false;
            error = "Action already assigned!";
        }
        else if (!this.allowDelete) {
            allowed = false;
            error = "This action cannot be deleted as per your permissions!";
        }
        return { allowed, error }
    }
    allowDeleting = (e) => {
        return this.validateDelete(e.row.data).allowed;
    }

    validateAssign = (draftItem) => {
        let allowed = true;
        let error = "";
        if (draftItem.status === 2) {
            allowed = false;
            error = "Draft already assigned!";
        }
        return { allowed, error }
    }
    isAssignIconVisible = (e) => {
        return this.validateAssign(e.row.data).allowed;
    }


    onCustomFiltersChanged = (property, e) => {
        this.setState({ isBusy: true, customFilter: { ...this.state.customFilter, [property]: e.value } }, () => {
            utils.setStorage(
                customFilterStorageKey,
                JSON.stringify(this.state.customFilter),
                customFilterStoragePeriod
            );
            this.loadDrafts();
        });
    }

    renderToolbarSwitchAssigned = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: 10 }}>
                    <span className="dx-button-text"><FormattedMessage id='ACTIONS.BUTTON.INCLUDE_ASSIGNED' /></span>
                </div>
                <div style={{ padding: 10 }}>
                    <Switch
                        style={{ marginLeft: 5 }}
                        defaultValue={this.state.customFilter.includeAssigned}
                        onValueChanged={this.onCustomFiltersChanged.bind(this, "includeAssigned")}
                        readOnly={false}
                    />
                </div>
            </div>
        )
    }
    onRowPrepared = (e) => {
        if (e.rowType === "data" && e.rowElement) {

            if (e.data?.status === 2) {
                //ASSIGNED
                e.rowElement.style.backgroundColor = '#DFFFE9';
            }
            else if (e.data?.status === 3) {
                //ERROR
                e.rowElement.style.backgroundColor = '#ffcccb';
            }

        }
    }

    renderResolvedByReference = (cellInfo) => {
        const wf = this.props.contractTemplate.workflowsQA[cellInfo.data.assignedworkflowid];
        if (cellInfo.data.status === 2 && cellInfo.data.assignedworkflowid && cellInfo.data.assignedentityid && wf) {
            let path = wf.paths.basePath + cellInfo.data.assignedentityid;

            return (
                <Link to={path}>
                    {cellInfo.data.assignedreferenceid}
                </Link>
            )

        }
        return '';
    }
    customSaveState = (state) => {
        if (!window.location.search) { //only save state if not in subscription view or resolving specific action view (identified by query param)
            localStorage.setItem(this.localStorageKey, JSON.stringify(state));
        }

    }
    customLoadState = () => {
        const state = JSON.parse(localStorage.getItem(this.localStorageKey)) || {};
        if (window.location.search) {
            const queryParams = new URLSearchParams(window.location.search);
            let genericdraftid = queryParams.get('genericdraftid');
            if (genericdraftid) {
                state.filterValue = ["contractgenericdraftid", "=", parseInt(genericdraftid)];
            }
        }

        //REMOVE ROW SELECTION
        if (state && state.selectedRowKeys) { delete state.selectedRowKeys };

        return state;

    }
    render() {
        return (
            <Portlet isLoading={this.state.isBusy} loadingDelay={0}>
                <PortletBody >
                    <DataGrid
                        ref={this.gridRef}
                        height={'67vh'}
                        dataSource={this.state.drafts}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        columnResizingMode='widget'
                        onRowRemoving={this.onRowRemoving}
                        style={{ width: '100%', height: '100%', maxHeight: '67vh' }}
                        name="ContractGenericDrafts"
                        keyExpr="contractgenericdraftid"
                        // onSelectionChanged={this.onSelectionChanged}
                        onExporting={this.onExporting}
                        loadPanel={{ enabled: false }}
                        // onInitialized={this.onDatagridInitialized}
                        onRowPrepared={this.onRowPrepared}
                    >

                        <Editing
                            //CACADING FORM DEMO IMPLEMENTATION
                            //https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CascadingLookups/React/Light/
                            // mode="popup"
                            allowUpdating={false}
                            allowDeleting={this.allowDeleting}
                            allowAdding={false}
                            confirmDelete={true}
                            //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxPopup/Configuration/
                            // popup={{ title: "Add action", minWidth: 600, height: "auto", width: "auto", showTitle: true }}
                            // useIcons={true}
                            //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/editing/texts/#deleteRow
                            texts={{
                                deleteRow: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REMOVE" }),
                                confirmDeleteTitle: "Delete Draft",
                                confirmDeleteMessage: "Are you sure you want to remove draft from contract?",
                            }}

                        >
                        </Editing>
                        <HeaderFilter visible={true} />
                        <FilterPanel visible={true} />
                        <FilterRow applyFilter="auto" visible={true} />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />

                        {/* 
                        CREATES PROBLEMS WHEN YOU SELECT ITEMS AND REFRESH THE PAGE
                        RENDERING OF GRID HAS PROBLEMS

                        */}
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customSave={this.customSaveState}
                            customLoad={this.customLoadState}
                        />

                        <Export enabled={true} fileName={this.props.intl.formatMessage({ id: 'GENERIC_DRAFTS.TITLE' })} />
                        <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.ID" })}
                            dataField="contractgenericdraftid"
                            visible={true}

                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "ACTIONS.FIELD.CREATE_DATE" })}
                            dataField="createdate"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.CREATE_BY" })}
                            dataField="createbyname"
                        />


                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.STATUS" })}
                            dataField="status"
                            lookup={{ dataSource: this.genericDraftStatuses, valueExpr: 'value', displayExpr: 'display' }}

                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SUBJECT" })}
                            dataField="subject"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.CLAUSE" })}
                            dataField="clause"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.SOURCE" })}
                            dataField="sourcechannel"
                            lookup={{ dataSource: this.genericDraftSources, valueExpr: 'value', displayExpr: 'display' }}

                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.SOURCE_EMAIL" })}
                            dataField="sourceemail"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.SOURCE_INSTANCE" })}
                            dataField="sourcefdinstance"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.USER_PARTY" })}
                            dataField="sourceuserparty"
                            lookup={{ dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.ASSIGNED_DATE" })}
                            dataField="assigneddate"
                            dataType="date"
                            format={(date) => moment(date).format('DD/MM/YYYY')}
                        // visible={false}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.ASSIGNED_BY" })}
                            dataField="assignedbyname"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERIC_DRAFTS.ASSIGNED_WORKFLOW" })}
                            dataField="assignedworkflowid"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.LINK" })}
                            dataField="assignedreferenceid"
                            cellRender={this.renderResolvedByReference}
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.ERROR' })}
                            dataField="error"
                        />
                        <Column
                            name="editButtons"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button icon="trash" name="delete" />
                        </Column>
                        <Column
                            name="asssignButton"
                            type="buttons"
                            width={40}
                            allowHiding={false}
                            allowReordering={false}
                            allowResizing={false}
                        >
                            <Button
                                name="assign"
                                hint={this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.ASSIGN' }) }
                                icon="send"
                                visible={this.isAssignIconVisible}
                                disabled={false}
                                onClick={this.assignIconClicked}
                            />
                        </Column>


                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                        <Toolbar>
                            <ToolbarItem location="before">
                                <div>
                                    <h3 style={{ fontFamily: SystemHelper.getThemeTextFont() ?? 'Poppins, Helvetica, sans-serif', fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                                        <FormattedMessage id='GENERIC_DRAFTS.TITLE' />
                                    </h3>
                                </div>
                            </ToolbarItem>

                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                render={this.renderToolbarSwitchAssigned}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                options={{
                                    icon: "refresh",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.REFRESH" }),
                                    onClick: this.loadDrafts,
                                }}
                            />

                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="exportButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="applyFilterButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="columnChooserButton"
                            />
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="searchPanel"
                            />
                        </Toolbar>

                    </DataGrid>
                </PortletBody>
                <ContractGenericDraftEditModal
                    visible={this.state.showEditDraftModal}
                    draftNotice={this.state.editingDraft}
                    onDialogResult={this.onEditDraftDialogResult}
                />
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    userProfile: store.auth.userProfile,
    // contractQuickMenuItems: store.contract.quickMenuItems,
});



export default injectIntl(withRouter(withSnackbar(connect(mapStateToProps)(GenericDrafts))));
